/**
 * 登录
 */
export const LOGIN_API = '/api/user/v1/login';
/**
 * 二维码登录
 */
export const QR_CODE_API = '/api/qrcode';
/**
 * 二维码登录检测
 */
export const QR_CODE_STATE_API = '/api/getLoginState/';
/**
 * 通过验证码登录
 */
export const LOGIN_BY_CODE_API = '/api/user/v1/sms/login';
/**
 * 重置密码
 */
export const RESET_PASSWORD_API = '/api/user/v1/modify';
/**
 * 计划直播列表
 */
export const LIVE_LIST_API = '/api/schedules/v1/list/live';
/**
 * 课程回放列表
 */
export const REPLAY_LIST_API = '/api/schedules/v1/list/vod';
/**
 * 科目列表
 */
export const SUBJECT_NAME_API = '/api/subjects';
/**
 * 发送短信验证码
 */
export const SEND_CODE_API = '/api/user/v1/sms/send';
/**
 * 阿里点播认证接口
 */
export const ALI_PLAY_AUTH = '/api/ali_vod/playAuth';
/**
 * 阿里点播认证接口（未登录）
 */
export const ALI_PLAY_AUTH_NOT_LOGIN = '/api/ali_vod/v2/playAuth';
/**
 * 用户资料
 */
export const USER_INFO_API = '/api/user/v1/profile';
/**
 * 修改用户资料
 */
export const UPDATE_USER_INFO_API = '/api/user/v1/updateProfile';

/**
 * 直播预约
 */
export const SUBCRIBE_API = '/api/schedules/v1/reserve';
/**
 * 修改直播预约时间
 */
export const CHANGE_SUBCRIBE_API = '/api/schedules/v1/rereserve';
/**
 * CC播放器认证
 */
export const CC_AUTH = '/api/live/sign';
/**
 * 获取视频详情
 */
export const VIDEO_DETAIL = '/api/schedules/v2/detail/';
/**
 * 获取直播视频详情
 */
export const LIVE_VIDEO_DETAIL = '/api/schedules/v1/live_detail/';
/**
 * 资料下载
 */
export const DOWNLOAD_RESOURCE = '/api/schedules/v1/download_file/';
/**
 * 修改密码(根据旧密码)
 */
export const UPDATE_PASSWORD_API = '/api/user/v1/update_password';
/**
 * 获取测试题目
 */
export const TEST_API = '/paper/questions';
/**
 * 交卷
 */
export const ANSWER_API = '/paper/answer';
/**
 * 获取题目解析
 */
export const ANALYSIS_API = '/paper/analyse';
/**
 * 获取首页直播预告
 */
export const HOME_LIVE_API = '/api/schedules/v2/list/live';
/**
 * 获取首页回看列表
 */
export const HOME_REPLAY_API = '/api/schedules/v2/list/vod';
/**
 * 获取首页轮播图
 */
export const HOME_BANNER_API = '/api/banner';
/**
 * 注册
 */
export const REGISTER_API = '/api/user/v1/register';
/**
 * 公开课列表
 */
export const OPEN_COURSE_API = '/api/schedules/v2/list/open ';
/**
 * 公开课资讯
 */
export const OPEN_COURSE_NEWS_API = '/api/article/list';
/**
 * 取消预约
 */
export const CANCEL_SUBCRIBE_API = '/api/schedules/v1/unreserve';

/**
 * 统计用户看视频时间
 * @type {string}
 */
export const REPORT_VIDEO_DURATION = '/api/schedules/v1/report';

/**
 * 获取图形验证码
 */
export const CAPTCHA_INFO_API = '/api/sms/captcha_info';
